/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const contentBoxHeadStyle = {
  contentBoxHeader: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    textAlign: "left",
  },
  imageContainer: {
    alignItems: "stretch",
    width: "70px",
    height: "70px",
    padding: "14px",
    textAlign: "center",
  },
  headerIcon: {
    minWidth: "40px",
    minHeight: "40px",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  headerTitleContainer: {
    flexGrow: 1,
    wordWrap: "break-word",
  },
};

export default contentBoxHeadStyle;
